package com.patronat.top.library.media.data.remote

import com.patronat.top.core.network.NetworkResult
import com.patronat.top.core.network.safeApiCall
import com.patronat.top.dto.FileRegistrationRequest
import com.patronat.top.dto.FileRegistrationResponse
import com.patronat.top.dto.ImageType
import com.patronat.top.dto.UploadUrlResponse
import com.patronat.top.library.media.data.FileSource
import io.ktor.client.*
import io.ktor.client.call.*
import io.ktor.client.plugins.*
import io.ktor.client.request.*
import io.ktor.http.*
import io.ktor.client.plugins.onUpload

class MediaApi(
    private val authClient: HttpClient,
) {
    private val s3Client by lazy {
        HttpClient {

            install(BodyProgress)

            install(HttpTimeout) {
                requestTimeoutMillis = 30_000
                socketTimeoutMillis = 30_000
                connectTimeoutMillis = 15_000
            }
        }
    }

    suspend fun getUploadUrl(type: ImageType, contentType: String): NetworkResult<UploadUrlResponse> {
        return safeApiCall {
            authClient.get("media/upload-url") {
                parameter("type", type.name)
                parameter("contentType", contentType)
            }
        }
    }

    suspend fun uploadToS3(
        uploadUrl: String,
        file: FileSource,
        contentType: String,
        onProgress: ((sent: Long, total: Long) -> Unit)? = null
    ) {
        val response = s3Client.put(uploadUrl) {
            headers.append(HttpHeaders.ContentLength, file.size.toString())
            contentType(ContentType.parse(contentType))
            setBody(file.openStream())
            onUpload { sent, total ->
                onProgress?.invoke(sent, total ?: file.size)
            }
        }
        if (!response.status.isSuccess()) {
            throw Exception("AWS Upload failed: ${response.status}")
        }
    }

    suspend fun registerFile(fileKey: String, type: ImageType): NetworkResult<FileRegistrationResponse> {
        return safeApiCall {
            authClient.post("media/register") {
                contentType(ContentType.Application.Json)
                setBody(FileRegistrationRequest(fileKey, type))
            }
        }
    }
}
